const payment = [
  { value: "Fixed", label: "Fixed" },
  { value: "Month", label: "Month" },
  { value: "Permanent", label: "Permanent" },
  { value: "Freelancing", label: "Freelancing" },
];

export default payment;
